import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "../../lib/api";
import { PublicLayout } from "../../components/PublicLayout";

export function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [state, setState] = useState<"pending" | "ok" | "err">("pending");

  useEffect(() => {
    if (!token) return setState("err");
    api("/api/auth/verify-email", { method: "POST", body: JSON.stringify({ token }) })
      .then(() => setState("ok"))
      .catch(() => setState("err"));
  }, [token]);

  return (
    <PublicLayout variant="center">
      <div className="card p-8 max-w-md w-full text-center">
        {state === "pending" && <p className="text-slate-500">Prüfe Token …</p>}
        {state === "ok" && (
          <>
            <div className="text-4xl mb-2">✅</div>
            <p>E-Mail bestätigt. <Link to="/app" className="underline">Zum Dashboard</Link></p>
          </>
        )}
        {state === "err" && (
          <>
            <div className="text-4xl mb-2">❌</div>
            <p>Der Link ist ungültig oder abgelaufen. <Link to="/login" className="underline">Anmelden</Link></p>
          </>
        )}
      </div>
    </PublicLayout>
  );
}
